import { ProcessingAction } from '@/models/thread';

const STORAGE_KEY = 'processing-queue';
export const PROCESSING_TIMEOUT_MS = import.meta.env.VITE_TEST_MODE
  ? 60 * 1000
  : 15 * 60 * 1000; // 15 minutes

export const isProcessingExpired = (queryDate: string | Date) => {
  const now = Date.now();

  const date = typeof queryDate === 'string' ? new Date(queryDate) : queryDate;
  return date.getTime() < now - PROCESSING_TIMEOUT_MS;
};

export const queueProcessingAction = (threadData: ProcessingAction): void => {
  const existingData = localStorage.getItem(STORAGE_KEY);
  let processingActionQueue: Array<ProcessingAction> = [];

  if (existingData) {
    processingActionQueue = JSON.parse(existingData);
  }
  processingActionQueue = processingActionQueue.filter(
    (item) => item.threadID !== threadData.threadID
  );
  processingActionQueue.push(threadData);

  storeActionQueue(processingActionQueue);
};

export const fetchSingleProcessingAction = (
  threadID: string
): ProcessingAction | undefined => {
  const processingActionQueue = fetchProcessingQueue();
  return processingActionQueue.find((item) => item.threadID === threadID);
};

export const deleteFromProcessingQueue = (threadID: string): void => {
  const processingThreads = fetchProcessingQueue();
  const updatedThreads = processingThreads.filter(
    (item) => item.threadID !== threadID
  );

  storeActionQueue(updatedThreads);
};

export const storeActionQueue = (
  actionQueue: Array<ProcessingAction>
): void => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(actionQueue));
};

export const purgeProcessingQueue = (): void => {
  localStorage.removeItem(STORAGE_KEY);
};

export const fetchProcessingQueue = (): Array<ProcessingAction> => {
  const existingData = localStorage.getItem(STORAGE_KEY);
  if (existingData) {
    try {
      const parsedData = JSON.parse(existingData) as Array<ProcessingAction>;
      // Delete expired actions
      const validActions = parsedData.filter(
        (item) => !isProcessingExpired(new Date(item.ts))
      );
      if (validActions.length !== parsedData.length) {
        storeActionQueue(validActions);
      }

      return validActions;
    } catch (error) {
      console.error(
        'Error parsing processing threads from localStorage:',
        error
      );
      purgeProcessingQueue();
    }
  }
  return [];
};
